import {Injectable} from '@angular/core';
import {Platform} from 'ionic-angular';

import {CameraPreview, CameraPreviewOptions} from '@ionic-native/camera-preview';

import {MediaProvider} from '../../providers/media/media';

/*
  Generated class for the ProofCameraProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class ProofCameraProvider {

  private proofId: number = null;

  constructor(
    private platform: Platform,
    private cameraPreview: CameraPreview,
    private mediaProvider: MediaProvider,
  ) {
    console.log('Hello ProofCameraProvider Provider');
  }

  initiate(proofId: number, questionId: number, seconds: number, secondsRemaining: number) {
    console.log('ProofCameraProvider - Initiate');

    let that = this;
    this.proofId = proofId;

    this.platform.ready().then(() => {

      const options: CameraPreviewOptions = {
        x: 0,
        y: 0,
        width: window.innerWidth,
        height: window.innerHeight,
        camera: 'front',
        toBack: true,
        tapToFocus: false,
      };

      this.cameraPreview.startCamera(options).then(() => {
        console.log('ProofCameraProvider - Camera preview started!');

        that.cameraPreview.setFlashMode(that.cameraPreview.FLASH_MODE.ON);
        console.log('ProofCameraProvider - Enabled flash');

        // Take first selfie
        setTimeout(() => {
          that.takeSelfie(questionId, seconds, secondsRemaining);
        }, 800);
      });
    });
  }

  takeSelfie(questionId: number, seconds: number, secondsRemaining: number) {
    console.log('ProofCameraProvider - Taking selfie');

    let that = this;

    if (this.proofId) {
      this.cameraPreview.takePicture({
        width: window.innerWidth,
        height: window.innerHeight,
        quality: 70
      }).then((imageData) => {
        console.log('ProofCameraProvider - Finished to take a selfie');

        that.mediaProvider.addBase64PhotoFromQuestion(
          questionId,
          seconds,
          secondsRemaining,
          imageData[0],
          () => console.log('ProofCameraProvider - Saved selfie'));
      }, (err) => {
        console.log('ProofCameraProvider - Could not take picture 1', err);
      }).catch((err) => {
        console.log('ProofCameraProvider - Could not take picture 2', err);
      });
    } else {

    }
  }

  destroy() {
    console.log('ProofCameraProvider - Destroy');

    this.proofId = null;
    this.cameraPreview.stopCamera().catch(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/proof-camera/proof-camera.ts